import { IllumioEventEmitter } from "../common/event_emitter.js";
import IllumioSupportUtils from "../common/support_utils.js";

export class ContainerOsSupportModel extends IllumioEventEmitter {
    constructor(softwareName, softwareTitle) {
        super();
        
        this.softwareName = softwareName;
        this.softwareTitle = softwareTitle;

        // this.dataLoadEvent = new IllumioEvent(this);
        let url = '/api/v1/pce_software/os_support/' + softwareName + '.json'
        if (IllumioSupportUtils.isPublicResource()) {
            url = '/api/v1/shared/pce_software/os_support/' + softwareName + '.json'
        }
        $.ajax({
            dataType: 'json',
            method: 'get',
            contentType: 'application/json; charset=utf-8',
            url: url,
            error: this.ajaxErrorHandler.bind(this),
            success: this.ajaxSuccessHandler.bind(this),
        });
    }

    ajaxSuccessHandler(response, textStatus, jqXHR) {
        console.debug('ajaxSuccessHandler() invoked.');
        if (response && response.data) {
            this.success = true;
            this.data = response.data;
            // this.dataLoadEvent.notify();
            this.emit('dataLoad', {});
        } else {
            this.success = false;
            this.error = response.error;
        }
    }

    ajaxErrorHandler() {
        console.warn('ajaxErrorHandler() invoked.');
        const result = new ContainerOsSupportResult();
        result.renderError(null);
    };

        /**
         * Public method
         */
        getRecordByVersion(selectedPceVersion) {
            if (this.data['os_content']) {
                for (let id in this.data['os_content']) {
                    if (this.data['os_content'][id].software_version===selectedPceVersion) {
                        return this.data['os_content'][id];
                    }
                }
            }
            return null;
        }
}

export class ContainerOsSupportView extends IllumioEventEmitter {
    constructor(model) {
        super();

        this.model = model;
        this.formDiv = document.getElementById('formDiv');
        this.versionSelect = document.getElementById('versionSelect');

        this.versionSelect.onchange = this.versionSelectOnChangeHandler.bind(this);

        // this.model.dataLoadEvent.attach(dataLoadEventHandler.bind(this));
        this.model.on('dataLoad', this.dataLoadEventHandler.bind(this));

        this.result = new ContainerOsSupportResult();
    }

        /**
         * Public method
         */
        showResult(selectElement) {
            this.result.render(selectElement, this.model.data);

            const softwareVersion = selectElement.options[selectElement.selectedIndex].text
            location.hash = softwareVersion.replace(/\s*\(LTS\)/, '');

            this.trackAnalytic();
        }

    versionSelectOnChangeHandler(event) {
        console.debug('versionSelectOnChangeHandler() invoked');
        this.showResult(event.target);
    }

    dataLoadEventHandler(event) {
        console.debug('dataLoadEventHandler() invoked!');
        if (this.model.success && this.model.data['os_content']) {
            let itemCounter = 0;
            const optionsArray = new Array();
            for (let id in this.model.data['os_content']) {
                const item = this.model.data['os_content'][id];

                if (item.pce_versions && item.pce_versions.length>0) {
                    var selectedPceVersionsForEachHandler = function(selectedPceVersion) {
                        optionsArray.push(new Option(selectedPceVersion, item.id));
                    }
                    item.pce_versions.forEach(selectedPceVersionsForEachHandler);
                }
            }
            if (optionsArray.length>0) {
                const optionsArraySortHandler = function (a, b) {
                    const aParts = a.text.split('.').map(Number);
                    const bParts = b.text.split('.').map(Number);
                    const maxLen = Math.max(aParts.length, bParts.length);
                    for (let i = 0; i < maxLen; i++) {
                        const aNum = aParts[i] || 0;
                        const bNum = bParts[i] || 0;

                        if (aNum !== bNum) {
                            return bNum - aNum; // DESCENDING
                        }
                    }
                    return 0;
                };  
                optionsArray.sort(optionsArraySortHandler);

                const optionsArrayForEachHandler = function(optionItem) {
                    console.debug(optionItem);
                    console.debug(this);
                    this.versionSelect.options.add(optionItem);
                }
                optionsArray.forEach(optionsArrayForEachHandler, this);
            }
            if (this.versionSelect.options.length>0) {
                this.defaultVersionSelect();
                this.formDiv.classList.remove('hidden');
                $(this.versionSelect).change();
            } else {
                this.result.renderError(null);
            }
        }
    }

    defaultVersionSelect() {
        let found = false;
        if (location.hash && location.hash.length>1) {
            var record = this.model.getRecordByVersion(location.hash.substr(1));
            if (record) {
                for (var i=0;i<this.versionSelect.options.length;i++) {
                    var selectedSoftwareVersion = this.versionSelect.options[i].text;
                    if (record.pce_versions.indexOf(selectedSoftwareVersion)>=0) {
                        found = true;
                        this.versionSelect.options[i].selected = true;
                        break;
                    }
                }
            }
        }

        if (!found) {
            this.versionSelect.options.selectedIndex = 0;
        }
    }

    trackAnalytic() {
        if (IllumioSupportUtils && this.versionSelect.selectedIndex>=0) {
            const eventLabel = this.versionSelect.options[this.versionSelect.selectedIndex].text;
            console.debug(`eventLabel: ${eventLabel}`);
            IllumioSupportUtils.trackGaEvent('OS Support', this.model.softwareTitle, eventLabel);
        }

        const qs = IllumioSupportUtils.getJsonFromUrl(location.href);
        if (qs && qs['source']) {
            IllumioSupportUtils.trackGaEvent('OS Support', this.model.softwareTitle + ' Redirect', qs['source'])
            console.debug(`Tracked ${this.model.softwareTitle} redirect`);
        }
    }
}

export class ContainerOsSupportController {
    constructor(model, view) {
        this.model = model;
        this.view = view;
    }
}

export class ContainerOsSupportResult {
    constructor() {
        this.containerContent = document.getElementById('containerContent');
    }

        /**
         * Public method
         */
        render(selectElement, data) {
            let id = selectElement.value;
            let selectedVersion = selectElement.options[selectElement.selectedIndex].text;
            let selectedVersionRelease = '';
            let isLts = false;
            if (selectedVersion) {
                isLts = (selectedVersion.match(/\s*\(LTS\)/)) ? true : false;
                selectedVersion = selectedVersion.replace(/\s*\(LTS\)/, '');
                selectedVersionRelease = this.getVersionRelease(selectedVersion);
            }

            const record = data['os_content'][id];
            const compatiblePceVersions = [];
            for (let pceVersion in data['compatibility']) {
                if (data['compatibility'] && data['compatibility'][pceVersion]) {
                    const products = Object.keys(data['compatibility'][pceVersion]);
                    let product = null;
                    if (products.length>0) {
                        if (products.includes('k8s')) {
                            product = 'k8s';
                        }
                    }
                    if (product) {
                        const versions = Object.keys(data['compatibility'][pceVersion][product]);
                        if (versions.indexOf(selectedVersion)>=0 || versions.indexOf(selectedVersionRelease)>=0) {
                            const pceVersionRelease = this.getVersionRelease(pceVersion);
                            if (compatiblePceVersions.indexOf(pceVersionRelease)<0) {
                                compatiblePceVersions.push(pceVersionRelease);
                            }
                        }
                    }
                }
            }

            if (compatiblePceVersions.length>0) {
                this.containerContent.innerHTML = this.createPceCompatibilityTables(selectedVersion, compatiblePceVersions);
                this.containerContent.innerHTML += record.view;
            } else { //added in the else statementfor the kubernetes operator page, it would create new tables each time.
                this.containerContent.innerHTML = record.view;

            }
        }

        renderError(message) {
            if (!message) {
                message = `We're sorry that we have experienced technical difficulties in retrieving the content. Please try again later.`;
            }
            this.containerContent.innerHTML = message;
        }

    /**
     * Convert version (e.g., x.y.z) to release (e.g., x.y)
     * @param {*} version
     */
    getVersionRelease(version) {
        const tempArray = version.split('.');
        let versionRelease = null;
        if (tempArray.length>=2) {
            versionRelease = tempArray.slice(0, 2).join('.');
        }
        return versionRelease;
    }

    createPceCompatibilityTables(selectedVersion, compatiblePceVersions) {
        const compatibilityHtml = [];

        const versionSelect = document.getElementById('versionSelect');
        let productName = '';
        if (versionSelect && versionSelect.previousElementSibling) {
            productName = versionSelect.previousElementSibling.textContent;
            productName = productName.replace(/Version\s*$/i, '');
        }

        compatibilityHtml.push('<h2>Compatibility for ');
        compatibilityHtml.push(productName);
        compatibilityHtml.push(selectedVersion);
        compatibilityHtml.push('</h2>')

        const tableHeaders = ['Software type', 'Version'];
        compatibilityHtml.push('<table class="ilo-tabular">');
        compatibilityHtml.push('<tbody>');
        compatibilityHtml.push('<tr>');
        for (let i in tableHeaders) {
            compatibilityHtml.push('<th>');
            compatibilityHtml.push(tableHeaders[i]);
            compatibilityHtml.push('</th>');
        }
        compatibilityHtml.push('</tr>');

        compatibilityHtml.push('<tr>');
        compatibilityHtml.push('<td>PCE</td>');
        compatibilityHtml.push('<td>');
        const compatiblePceVersionsForEachHandler = function(compatiblePceVersion) {
            compatibilityHtml.push('<li>');
            compatibilityHtml.push(compatiblePceVersion);
            compatibilityHtml.push('</li>');
        }
        compatibilityHtml.push('<ul>');
        compatiblePceVersions.forEach(compatiblePceVersionsForEachHandler);
        compatibilityHtml.push('</ul>');
        compatibilityHtml.push('</td>');
        compatibilityHtml.push('</tr>');

        compatibilityHtml.push('</tbody>');
        compatibilityHtml.push('</table>');

        return compatibilityHtml.join('');
    }
}
